// ======= plugin import ======== //
import React,{useEffect, useState} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { Drawer } from "antd";
import { Link, useLocation } from 'react-router-dom';
import { Formik, Form, Field, ErrorMessage, useFormikContext  } from 'formik';
import axios from 'axios';
import Select from 'react-select'
import { toast } from 'react-toastify';

// ========= component import =========== //
import HeaderStyle from '../style/LandingHeaderStyle.module.css';
import ButtonLoader from '../../../../app/component/common/ButtonLoader';
import ValidationMessage from '../../../../app/component/common/ValidationMessage';
import { ValidateEmail, refreshCaptcha } from '../../../../app/component/common/Helper';
import { countryCodeList } from '../../../../app/constants/selectOptions';

const LandingHeader = () => {
    const api_base_url = process.env.REACT_APP_API_URL;

    // ============== define all state =========== //
    const [scrolled, setScrolled] = useState(false);
    const [mobileMenuIsOpen, setMobileMenuIsOpen] = useState(false);

    const [demoBookingFormData, setDemoBookingFormData] = useState({
        book_inp_name: '',
        book_inp_email: '',
        country_code: null,
        book_inp_phone: '',
        book_inp_landline: '',
        book_inp_organization: '',
        book_purpose: [],
        your_messages: '',
        book_channel: [],
        book_volume: '',
        book_crm: '',
        book_terms_and_conditions: false
    });
    const [demoBookingFormError, setDemoBookingFormError] = useState({});
    const [ submitButtonLoader, setSubmitButtonLoader ] = useState(false)

    // ================= end state ============= //

    const location = useLocation();
    useEffect(() => {
        setMobileMenuIsOpen(false)
    }, [location]);

    useEffect(() => {
        const handleScroll = () => {
            const offset = window.scrollY;
            if (offset > 50) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);
    const menuDrawerOnClose = () => {
        setMobileMenuIsOpen(false)
    }
    const mobileMenuIsOpenOnClick = () => {
        setMobileMenuIsOpen(true)
    }

    const validateField = (name, value) => {
        let error = "";
        if (name === "book_inp_name") {
            if (!value) {
                error = "Name is required";
            } 
        }

        if(name === 'book_inp_email'){
            if (!value) {
                error = "Email is required";
            }
            else if (!ValidateEmail(value)) {
                error = "Invalid email address";
            }
        }
        if(name === 'country_code'){
            if (!value) {
                error = "Country code is required";
            }
        }
        if(name === 'book_inp_phone'){
            if (!value) {
                error = "Phone no is required";
            }
        }

        if(name === 'book_inp_organization'){
            if (!value) {
                error = "Organization is required";
            }
        }

        if(name === 'your_messages'){
            if (!value) {
                error = "Messages is required";
            }
        }

        if(name === 'book_terms_and_conditions'){
            if (!value) {
                error = "Terms and Conditions is required.";
            }
        }

        return error;
    }

    const inputChangeHandler = (selectedOption, actionMeta) => {
        if(selectedOption?.target){
            // ----- for input ----- //
            const { name, value, type, checked  } = selectedOption.target;
            let fieldValue;
            if(type === 'checkbox'){
                if(name === 'book_terms_and_conditions'){
                    fieldValue = checked
                }
                else if(name === 'book_purpose'){
                    fieldValue = [...demoBookingFormData.book_purpose];
                    if (checked) {
                        if (!fieldValue.includes(value)) {
                            fieldValue.push(value);
                        }
                    }
                    else{
                        fieldValue = fieldValue.filter((item) => item !== value);
                    }
                }
                else if(name === 'book_channel'){
                    fieldValue = [...demoBookingFormData.book_channel];
                    if (checked) {
                        if (!fieldValue.includes(value)) {
                            fieldValue.push(value);
                        }
                    }
                    else{
                        fieldValue = fieldValue.filter((item) => item !== value);
                    }
                }
            }
            else{
                if (name === 'book_inp_phone' || name === 'book_inp_landline'){
                    fieldValue = value.replace(/\D/g, '');
                } else {
                    fieldValue = value;
                }
            }
            const fieldError = validateField(name, fieldValue);
            setDemoBookingFormError((prevErrors) => ({
                ...prevErrors,
                [name]: fieldError,
            }));
            setDemoBookingFormData((prevData) => ({
                ...prevData,
                [name]: fieldValue,
            }));
        }
        else if(actionMeta?.name){
            const { name } = actionMeta;
            if(name === 'country_code'){
                setDemoBookingFormData((prevData) => ({
                    ...prevData,
                    [name]: selectedOption,
                }));
            }
            const fieldError = validateField(name, selectedOption?.value);
            setDemoBookingFormError((prevErrors) => ({
                ...prevErrors,
                [name]: fieldError,
            }));
        }
    };

    const formSubmitHandler = async (e) => {
        e.preventDefault();

        const newErrors = {};

        for (const key in demoBookingFormData) {
            newErrors[key] = validateField(key, demoBookingFormData[key]);
        }
        setDemoBookingFormError(newErrors);

        if (Object.keys(newErrors).every((key) => !newErrors[key])) {
            setSubmitButtonLoader(true);
            const captchaToken = await refreshCaptcha();
            demoBookingFormData.capchaToken = captchaToken
            const api_headers = {
                headers: { 
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                }
            };
            try{
                await axios.post(`${api_base_url}api/save-booking-info`, demoBookingFormData, api_headers)
                .then(async (res) => {
                    if(res.data.status === 'success') {
                        toast.success(res.data.message);
                    } else if(res.data.status === 'error') {
                        toast.error(res.data.message);
                    }
                })
                .catch((error) => {
                    console.error(error);
                })
            }
            catch(e){
                console.error(e);
            }
            finally{
                setDemoBookingFormData({
                    book_inp_name: '',
                    book_inp_email: '',
                    country_code: null,
                    book_inp_phone: '',
                    book_inp_landline: '',
                    book_inp_organization: '',
                    book_purpose: [],
                    your_messages: '',
                    book_channel: [],
                    book_volume: '',
                    book_crm: '',
                    book_terms_and_conditions: false
                });
                setDemoBookingFormError({})
                setSubmitButtonLoader(false)
            }
        }
    }

    const formResetOnClick = () => {
        setDemoBookingFormData({
            book_inp_name: '',
            book_inp_email: '',
            country_code: null,
            book_inp_phone: '',
            book_inp_landline: '',
            book_inp_organization: '',
            book_purpose: [],
            your_messages: '',
            book_channel: [],
            book_volume: '',
            book_crm: '',
            book_terms_and_conditions: false
        });
        setDemoBookingFormError({})
    }
  
    return (
        <>
            {/* <ToastContainer/> */}
            <style>
                {
                    `
                        .video-modal{
                            background-color:#0000005c;
                        }
                        .video-modal .cursor-pointer{
                            position:absolute;
                            background:#fff;
                            padding:12px 15px;
                            border-radius:50%;
                            margin:14px;
                            right:15px;
                        }
                        input[type="checkbox"] {
                            background-color: white;
                        }
                        @media (max-width:575px){
                            .m-gap {
                                gap:5px !important;
                            }
                        }
                        
                        .accordion-item{
                            border: none !important;
                        }
                    `
                }
            </style>
            <header className={`header-area style-1 pos-abs zi-9 ${scrolled ? HeaderStyle.headerScrolled : ''}`}>
                <div className="container">
                    <div className="header-area__inner">
                        <div className="header__logo">
                            <Link to="/">
                                <img src="/truvoice_logo-new.png" className={`normal-logo ${HeaderStyle.headerLogo}`} alt="Site Logo" />
                            </Link>
                        </div>
                        <div className={`header__nav pos-center ${HeaderStyle.navLinks}`}>
                            <nav className="main-menu">
                                <ul>
                                    <li className="menu-item-has-children">
                                        <Link to="#">Products</Link>
                                        <ul className="dp-menu">
                                            <li>
                                                <Link to="/truvoice-platform">
                                                    TruVoice AI Platform
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/fully-managed">
                                                    Fully-managed Agents
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="#">
                                                    TruChat Widget
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="#">
                                                    TruLive Chat
                                                </Link>
                                            </li>
                                        </ul>
                                    </li>
                                    <li className="menu-item-has-children">
                                        <Link to="#">Services</Link>
                                        <ul className="dp-menu">
                                            <li>
                                                <Link to="/custom-built">
                                                    Custom-built Agents
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/language-models">
                                                    Language Models
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/ai-ml-services">
                                                    AI/ML Services
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="#">
                                                    Application Development
                                                </Link>
                                            </li>
                                        </ul>
                                    </li>
                                    <li>
                                        <Link to="#">Pre-built Language Models</Link>
                                    </li>
                                    {/* <li className="menu-item-has-children">
                                        <Link to="#">Pricing</Link>
                                        <ul className="dp-menu">
                                            <li>
                                                <Link to="#">
                                                    Platform Pricing
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="#">
                                                    Fully Managed Pricing
                                                </Link>
                                            </li>
                                        </ul>
                                    </li> */}
                                    <li><Link to="/resources">Resources</Link></li>
                                </ul>
                            </nav>
                        </div>
                        <div className={`header__button ${HeaderStyle.requestDemoBtn}`}>
                            <button 
                                className="wc-btn wc-btn-primary btn-text-flip p-5 me-5"
                                data-bs-toggle="modal"
                                data-bs-target="#book_demo_modal"
                            > 
                                <span data-text="Request Demo" className="fs-4">Request Demo</span>
                            </button>
                            <Link 
                                className="wc-btn wc-btn-primary btn-text-flip p-5 w-100px"
                                to={'/login'}
                            >
                                <span data-text="Sign In" className='fs-4'>Sign In</span>
                            </Link>
                        </div>
                        <div className={`header__button ${HeaderStyle.menuIcon}`}>
                            <FontAwesomeIcon icon={faBars} className='text-gray-700 fs-2x' onClick={mobileMenuIsOpenOnClick}/>
                        </div>
                    </div>
                </div>
            </header>
            {/* ============ mobile menu drawer ========== */}
            <Drawer
                width={300}
                open={mobileMenuIsOpen}
                placement={'left'}
                closable={false}
                maskClosable={true}
                onClose={menuDrawerOnClose}
                styles={{ body: { overflowX: "hidden" } }}
            >
                <div className="menu menu-rounded menu-column menu-lg-row my-5 my-lg-0 align-items-stretch fw-semibold px-2 px-lg-0">
                    <div className='ms-5 mb-8'>
                        <img alt='Logo' src='/truvoice_logo-new.png' className='h-30px' />
                    </div>
                    <div className="accordion p-5" id="products_accro">
                        <div className="accordion-item">
                            <span className="menu-link" id="headingOne" data-bs-toggle="collapse" data-bs-target="#accro_one" aria-expanded="true" aria-controls="accro_one">
                                <span className="menu-title fs-5">Products</span>
                                <span className="menu-arrow"></span>
                            </span>
                            <div id="accro_one" className="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#products_accro">
                                <div className="accordion-body ps-0 pt-0 pb-0">
                                    <div className="" sai-hidden-height="229">
                                        <div className="menu-item">
                                            <Link className="menu-link" to="/truvoice-platform">
                                                <span className="menu-bullet">
                                                    <span className="bullet bullet-dot"></span>
                                                </span>
                                                <span className="menu-title">TruVoice AI Platform</span>
                                            </Link>
                                        </div>
                                        <div className="menu-item">
                                            <Link className="menu-link" to="/fully-managed">
                                                <span className="menu-bullet">
                                                    <span className="bullet bullet-dot"></span>
                                                </span>
                                                <span className="menu-title">Fully-managed Agents</span>
                                            </Link>
                                        </div>
                                        <div className="menu-item">
                                            <Link className="menu-link" to="#">
                                                <span className="menu-bullet">
                                                    <span className="bullet bullet-dot"></span>
                                                </span>
                                                <span className="menu-title">TruChat Widget</span>
                                            </Link>
                                        </div>
                                        <div className="menu-item">
                                            <Link className="menu-link" to="#">
                                                <span className="menu-bullet">
                                                    <span className="bullet bullet-dot"></span>
                                                </span>
                                                <span className="menu-title">TruLive Chat</span>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="accordion p-5" id="services_accro">
                        <div className="accordion-item">
                            <span className="menu-link" id="headingOne" data-bs-toggle="collapse" data-bs-target="#accro_two" aria-expanded="true" aria-controls="accro_two">
                                <span className="menu-title fs-5">Services</span>
                                <span className="menu-arrow"></span>
                            </span>
                            <div id="accro_two" className="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#services_accro">
                                <div className="accordion-body ps-0 pt-0 pb-0">
                                    <div className="" sai-hidden-height="229">
                                        <div className="menu-item">
                                            <Link className="menu-link" to="/custom-built">
                                                <span className="menu-bullet">
                                                    <span className="bullet bullet-dot"></span>
                                                </span>
                                                <span className="menu-title">Custom-built Agents</span>
                                            </Link>
                                        </div>
                                        <div className="menu-item">
                                            <Link className="menu-link" to="/language-models">
                                                <span className="menu-bullet">
                                                    <span className="bullet bullet-dot"></span>
                                                </span>
                                                <span className="menu-title">Language Models</span>
                                            </Link>
                                        </div>
                                        <div className="menu-item">
                                            <Link className="menu-link" to="/ai-ml-services">
                                                <span className="menu-bullet">
                                                    <span className="bullet bullet-dot"></span>
                                                </span>
                                                <span className="menu-title">AI/ML Services</span>
                                            </Link>
                                        </div>
                                        <div className="menu-item">
                                            <Link className="menu-link" to="#">
                                                <span className="menu-bullet">
                                                    <span className="bullet bullet-dot"></span>
                                                </span>
                                                <span className="menu-title">Application Development</span>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="menu-item here p-3">
                        <Link className='menu-link' to="#">
                            <span className="menu-title fs-5">Pre-built Language Models</span>
                        </Link>
                    </div>
                    <div className="menu-item here p-3">
                        <Link className='menu-link' to="/resources">
                            <span className="menu-title fs-5">Resources</span>
                        </Link>
                    </div>
                    <button className="btn wc-btn wc-btn-primary round-btn fs-5 mx-5 p-5 mt-5" data-bs-toggle="modal"
                        data-bs-target="#book_demo_modal">
                        Request Demo
                    </button>
                </div>
            </Drawer>
            <div className="modal fade modal-lg video-modal" id="book_demo_modal" data-bs-backdrop="false" data-bs-keyboard="true">
                <div className="modal-dialog modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-body p-0 overflow-x-hidden">
                            <div className='row border p-10 custom-card-bg br-20'>
                                <div className='col-md-12'>
                                    <div className='text-center'>
                                        <h2 className="section-title fs-2hx text-grad-3">
                                            Book Your Free Demo
                                        </h2>
                                        <p className="text my-3 pe-5 fs-3 text-gray-700">
                                            Discover how our solution can work for you—schedule a personalized walkthrough
                                        </p>
                                    </div>
                                    <form onSubmit={formSubmitHandler} autoComplete="off">
                                        <div className='row'>
                                            <div className='col-md-6'>
                                                <div className="form-floating mb-5">
                                                    <input 
                                                        type="text" 
                                                        className="form-control" 
                                                        id="book_inp_name" 
                                                        placeholder="Name" 
                                                        autoComplete="new-password" 
                                                        name="book_inp_name"
                                                        onChange={inputChangeHandler}
                                                        value={demoBookingFormData.book_inp_name}
                                                    />
                                                    <label htmlFor="book_inp_name" className='fs-4'>Name</label>
                                                    {
                                                        demoBookingFormError.book_inp_name && 
                                                        <ValidationMessage className='text-danger mt-2' message ={demoBookingFormError.book_inp_name}/>
                                                    }
                                                </div>
                                            </div>
                                            <div className='col-md-6'>
                                                <div className="form-floating mb-5">
                                                    <input 
                                                        type="text" 
                                                        className="form-control" 
                                                        id="book_inp_email" 
                                                        placeholder="Email" 
                                                        autoComplete="new-password" 
                                                        name="book_inp_email"
                                                        onChange={inputChangeHandler}
                                                        value={demoBookingFormData.book_inp_email}
                                                    />
                                                    <label htmlFor="book_inp_email" className='fs-4'>Email</label>
                                                    {
                                                        demoBookingFormError.book_inp_email && 
                                                        <ValidationMessage className='text-danger mt-2' message ={demoBookingFormError.book_inp_email}/>
                                                    }
                                                </div>
                                            </div>
                                            <div className='col-md-4'>
                                                <Select
                                                    className="react-select-styled"
                                                    classNamePrefix="react-select"
                                                    options={countryCodeList}
                                                    placeholder="Select country code"
                                                    name='country_code'
                                                    onChange={inputChangeHandler}
                                                    value={demoBookingFormData.country_code}
                                                />
                                                {
                                                    demoBookingFormError.country_code && 
                                                    <ValidationMessage className='text-danger mt-2' message ={demoBookingFormError.country_code}/>
                                                }
                                            </div>
                                            <div className='col-md-4'>
                                                <div className="form-floating mb-5">
                                                    <input 
                                                        type="text" 
                                                        className="form-control" 
                                                        id="book_inp_phone" 
                                                        placeholder="Phone" 
                                                        autoComplete="new-password" 
                                                        name="book_inp_phone"
                                                        onChange={inputChangeHandler}
                                                        value={demoBookingFormData.book_inp_phone}
                                                    />
                                                    <label htmlFor="book_inp_phone" className='fs-4'>Phone</label>
                                                    {
                                                        demoBookingFormError.book_inp_phone && 
                                                        <ValidationMessage className='text-danger mt-2' message ={demoBookingFormError.book_inp_phone}/>
                                                    }
                                                </div>
                                            </div>
                                            <div className='col-md-4'>
                                                <div className="form-floating mb-5">
                                                    <input 
                                                        type="text" 
                                                        className="form-control" 
                                                        id="book_inp_landline" 
                                                        placeholder="Landline" 
                                                        autoComplete="new-password"
                                                        name="book_inp_landline" 
                                                        onChange={inputChangeHandler}
                                                        value={demoBookingFormData.book_inp_landline}
                                                    />
                                                    <label htmlFor="book_inp_landline" className='fs-4'>Landline</label>
                                                </div>
                                            </div>
                                            <div className='col-md-12'>
                                                <div className="form-floating mb-5">
                                                    <input 
                                                        type="text"
                                                        className="form-control" 
                                                        id="book_inp_organization" 
                                                        placeholder="Organization" 
                                                        autoComplete="new-password"
                                                        name="book_inp_organization"
                                                        onChange={inputChangeHandler}
                                                        value={demoBookingFormData.book_inp_organization}
                                                    />
                                                    <label htmlFor="book_inp_organization" className='fs-4'>
                                                        Organization
                                                    </label>
                                                    {
                                                        demoBookingFormError.book_inp_organization && 
                                                        <ValidationMessage className='text-danger mt-2' message ={demoBookingFormError.book_inp_organization}/>
                                                    }
                                                </div>
                                            </div>
                                            <div className='col-md-12 mb-5'>
                                                <div className='row border border-primary border-dashed p-4 rounded m-auto m-gap'>
                                                    <div className='col-md-4'>
                                                        <div className="form-check">
                                                            <input 
                                                                className="form-check-input" 
                                                                type="checkbox" 
                                                                value="Sales" 
                                                                id="sales"
                                                                name="book_purpose"
                                                                onChange={inputChangeHandler}
                                                                checked={demoBookingFormData.book_purpose?.includes("Sales") || false}
                                                            />
                                                            <label className="form-check-label mt-1 text-gray-700" htmlFor="sales">
                                                                Sales
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-4'>
                                                        <div className="form-check">
                                                            <input 
                                                                className="form-check-input" 
                                                                type="checkbox" 
                                                                value="Services" 
                                                                id="services"
                                                                name="book_purpose"
                                                                onChange={inputChangeHandler}
                                                                checked={demoBookingFormData.book_purpose?.includes("Services") || false}
                                                            />
                                                            <label className="form-check-label mt-1 text-gray-700" htmlFor="services">
                                                                Services
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-4'>
                                                        <div className="form-check">
                                                            <input 
                                                                className="form-check-input" 
                                                                type="checkbox" 
                                                                value="Others" 
                                                                id="others"
                                                                name="book_purpose"
                                                                onChange={inputChangeHandler}
                                                                checked={demoBookingFormData.book_purpose?.includes("Others") || false}
                                                            />
                                                            <label className="form-check-label mt-1 text-gray-700" htmlFor="others">
                                                                Others
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-md-12 mb-5'>
                                                <div className="form-floating">
                                                    <textarea
                                                        as="textarea"
                                                        className="form-control" 
                                                        placeholder="How can we help you?" 
                                                        id="your_messages"
                                                        name="your_messages"
                                                        onChange={inputChangeHandler}
                                                        value={demoBookingFormData.your_messages}
                                                    ></textarea>
                                                    <label htmlFor="your_messages" className='fs-4'>
                                                        How can we help you?
                                                    </label>
                                                    {
                                                        demoBookingFormError.your_messages && 
                                                        <ValidationMessage className='text-danger mt-2' message ={demoBookingFormError.your_messages}/>
                                                    }
                                                </div>
                                            </div>
                                            <div className='col-md-12 mb-5'>
                                                <div className='row border border-primary border-dashed p-4 rounded m-auto m-gap'>
                                                    <div className='col-md-4 mb-3'>
                                                        <div className="form-check ">
                                                            <input 
                                                                className="form-check-input" 
                                                                type="checkbox" 
                                                                value="Web" 
                                                                id="ch_web"
                                                                name="book_channel"
                                                                onChange={inputChangeHandler}
                                                                checked={demoBookingFormData.book_channel?.includes("Web") || false}
                                                            />
                                                            <label className="form-check-label mt-1 text-gray-700" htmlFor="ch_web">
                                                                Web
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-4 mb-3'>
                                                        <div className="form-check ">
                                                            <input 
                                                                className="form-check-input" 
                                                                type="checkbox" 
                                                                value="Facebook" 
                                                                id="ch_facebook" 
                                                                name="book_channel"
                                                                onChange={inputChangeHandler}
                                                                checked={demoBookingFormData.book_channel?.includes("Facebook") || false}
                                                            />
                                                            <label className="form-check-label mt-1 text-gray-700" htmlFor="ch_facebook">
                                                                Facebook
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-4 mb-3'>
                                                        <div className="form-check ">
                                                            <input 
                                                                className="form-check-input" 
                                                                type="checkbox" 
                                                                value="WhatsApp" 
                                                                id="cd_whatsapp"
                                                                name="book_channel"
                                                                onChange={inputChangeHandler}
                                                                checked={demoBookingFormData.book_channel?.includes("WhatsApp") || false}
                                                            />
                                                            <label className="form-check-label mt-1 text-gray-700" htmlFor="cd_whatsapp">
                                                                WhatsApp
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-4'>
                                                        <div className="form-check ">
                                                            <input 
                                                                className="form-check-input" 
                                                                type="checkbox" 
                                                                value="Mobile" 
                                                                id="ch_mobile"
                                                                name="book_channel"
                                                                onChange={inputChangeHandler}
                                                                checked={demoBookingFormData.book_channel?.includes("Mobile") || false}
                                                            />
                                                            <label className="form-check-label mt-1 text-gray-700" htmlFor="ch_mobile">
                                                                Mobile
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-4'>
                                                        <div className="form-check ">
                                                            <input 
                                                                className="form-check-input" 
                                                                type="checkbox" 
                                                                value="Telegram" 
                                                                id="ch_telegram"
                                                                name="book_channel"
                                                                onChange={inputChangeHandler}
                                                                checked={demoBookingFormData.book_channel?.includes("Telegram") || false}
                                                            />
                                                            <label className="form-check-label mt-1 text-gray-700" htmlFor="ch_telegram">
                                                                Telegram
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-4'>
                                                        <div className="form-check ">
                                                            <input 
                                                                className="form-check-input" 
                                                                type="checkbox" 
                                                                value="Others" 
                                                                id="ch_others" 
                                                                name="book_channel"
                                                                onChange={inputChangeHandler}
                                                                checked={demoBookingFormData.book_channel?.includes("Others") || false}
                                                            />
                                                            <label className="form-check-label mt-1 text-gray-700" htmlFor="ch_others">
                                                                Others
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-md-6'>
                                                <div className="form-floating mb-7">
                                                    <input 
                                                        type="text" 
                                                        className="form-control" 
                                                        id="book_volume" 
                                                        placeholder="Volume of interaction expected in a month" autoComplete="new-password"
                                                        name="book_volume"
                                                        onChange={inputChangeHandler}
                                                        value={demoBookingFormData.book_volume}
                                                    />
                                                    <label htmlFor="book_volume" className='fs-4'>Volume of interaction expected in a month</label>
                                                </div>
                                            </div>
                                            <div className='col-md-6'>
                                                <div className="form-floating mb-7">
                                                    <input
                                                        type="text" 
                                                        className="form-control" 
                                                        id="book_crm" 
                                                        placeholder="Name of CRM" 
                                                        autoComplete="new-password"
                                                        name="book_crm"
                                                        onChange={inputChangeHandler}
                                                        value={demoBookingFormData.book_crm}
                                                    />
                                                    <label htmlFor="book_crm" className='fs-4'>Name of CRM</label>
                                                </div>
                                            </div>
                                            <div className='col-md-12 mt-2'>
                                                <div className="form-check form-check-solid mt-3">
                                                    <input 
                                                        className="form-check-input bg-dark" 
                                                        type="checkbox" 
                                                        value="" 
                                                        id="flexCheckDefault" 
                                                        name="book_terms_and_conditions"
                                                        onChange={inputChangeHandler}
                                                        checked={demoBookingFormData.book_terms_and_conditions}
                                                    />
                                                    <label className="form-check-label mt-1 text-gray-700" htmlFor="flexCheckDefault">
                                                        I agree to TruVoice's Terms & Conditions of Use and Privacy Policy.
                                                    </label>
                                                    {
                                                        demoBookingFormError.book_terms_and_conditions && 
                                                        <ValidationMessage className='text-danger mt-2' message ={demoBookingFormError.book_terms_and_conditions}/>
                                                    }
                                                </div>
                                            </div>
                                            <div className='col-md-12 text-end mt-2'>
                                                <button 
                                                    className="btn btn-outline btn-outline-dark btn-active-light-dark me-2"
                                                    data-bs-dismiss="modal"
                                                    onClick={formResetOnClick}
                                                    type="button"
                                                >
                                                    Close
                                                </button>
                                                <button className={`btn btn-dark ${submitButtonLoader && 'disabled'}`} type="submit">
                                                    {
                                                        submitButtonLoader ? <ButtonLoader btnHtml='Please wait...' className='me-2'/> : 'Submit'
                                                    }
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default LandingHeader